"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JWTHandler = void 0;
var tslib_1 = require("tslib");
var auth_handler_1 = require("./auth-handler");
var type_checker_1 = require("./type-checker");
var JWTHandler = (function () {
    function JWTHandler() {
    }
    JWTHandler.parseUserFromJwt = function (token) {
        if (!token) {
            console.error('token can not be founded');
            return null;
        }
        var user;
        try {
            var base64Url = token.split('.')[1];
            var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            var jsonPayload = decodeURIComponent(window
                .atob(base64)
                .split('')
                .map(function (c) { return "%".concat("00".concat(c.charCodeAt(0).toString(16)).slice(-2)); })
                .join(''));
            user = JSON.parse(jsonPayload);
        }
        catch (e) {
            console.error(e);
        }
        if ((0, type_checker_1.isUserFromToken)(user))
            return user;
        console.error('user can not found in token');
        return null;
    };
    var _a;
    _a = JWTHandler;
    JWTHandler.getCookie = function (name) {
        var match = document.cookie.match(new RegExp("(^| )".concat(name, "=([^;]+)")));
        if (!(match === null || match === void 0 ? void 0 : match[2]))
            return null;
        var cookie = decodeURIComponent(match[2]);
        var body = JSON.parse(cookie);
        return body;
    };
    JWTHandler.setCookie = function (key, value, options) {
        var body = JSON.stringify(value);
        var cookie = encodeURIComponent(body);
        var optionsString = Object.entries(options !== null && options !== void 0 ? options : {})
            .map(function (_b) {
            var k = _b[0], v = _b[1];
            return "".concat(k, "=").concat(String(v));
        })
            .join(';');
        document.cookie = "".concat(key, "=").concat(cookie, ";").concat(optionsString);
    };
    JWTHandler.getUserFromToken = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var authAccessToken, token, _b, _id, email;
        return tslib_1.__generator(_a, function (_c) {
            switch (_c.label) {
                case 0: return [4, auth_handler_1.AuthHandler.getAccessToken()];
                case 1:
                    authAccessToken = _c.sent();
                    token = JWTHandler.getCookie('rentspreeUserToken');
                    try {
                        _b = JWTHandler.parseUserFromJwt(authAccessToken || token.access_token), _id = _b._id, email = _b.email;
                        return [2, { userId: _id, email: email }];
                    }
                    catch (e) {
                        console.error(e);
                        return [2, null];
                    }
                    return [2];
            }
        });
    }); };
    JWTHandler.getAxiosConfig = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var authAccessToken, token, accessToken;
        return tslib_1.__generator(_a, function (_b) {
            switch (_b.label) {
                case 0: return [4, auth_handler_1.AuthHandler.getAccessToken()];
                case 1:
                    authAccessToken = _b.sent();
                    token = JWTHandler.getCookie('rentspreeUserToken');
                    accessToken = authAccessToken || (token === null || token === void 0 ? void 0 : token.access_token);
                    return [2, {
                            headers: {
                                Authorization: "Bearer ".concat(accessToken || ''),
                            },
                        }];
            }
        });
    }); };
    return JWTHandler;
}());
exports.JWTHandler = JWTHandler;
//# sourceMappingURL=jwt-handler.js.map